import React, { useState } from "react";
import { StarFill, Star } from "react-bootstrap-icons";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function MakeAReviewModal({ cancelModal, id, refreshData }) {
  const [selectedStars, setSelectedStars] = useState(0);
  const [selectedStarsErr, setSelectedStarsErr] = useState("");
  const [reviewText, setReviewText] = useState("");
  const [reviewTextErr, setReviewTextErr] = useState("");
  const [serverError, setServerError] = useState(""); // State for server error
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const { user } = useAuthContext();
//styled
  const handleStarClick = (index) => {
    setSelectedStars(index + 1);
  };

  const handleSubmit = async () => {
    setSelectedStarsErr("");
    setReviewTextErr("");
    setServerError(""); // Reset server error on new submission

    if (selectedStars === 0) {
      setSelectedStarsErr("Please select a star rating.");
    }
    if (!reviewText) {
      setReviewTextErr("Please write a review.");
    }

    if (selectedStars > 0 && reviewText) {
      setIsLoading(true);

      try {
        const createRating = {
          content: reviewText,
          stars: selectedStars,
          clubId: id,
        };

        const ratingResponse = await axios.post(
          `${ApiConnectionString}/api/Rating`,
          createRating,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (ratingResponse.status === 200) {
          setComplete(true);
         
        }
      }catch (error) {
        console.error("Error submitting review:", error);
      
        // Try to extract the error message from different possible locations in the response
        const errorMessage =
          error.response?.data?.message ||  // Standard message
          error.response?.data?.error ||    // Sometimes it may be under `error`
          error.response?.data ||           // In some cases, the entire data is the message
          error.message ||                  // Generic JS error message
          "An error occurred. Please try again."; // Fallback message
      
        setServerError(errorMessage); // Set the extracted message to state
      }finally {
        setIsLoading(false);
      }
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else if (complete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Review submitted</p></div> 
        <p>Your review has been submitted successfully.</p>

          <div className="send-modal-footer">
            <button className="pointer cancelButton fw-bold mx-2 px-3" onClick={() => {cancelModal(); refreshData();}}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Review This Club </p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>

          <div className="mb-3">
            <p className="mb-1">Rate your experience:</p>
            <div className="d-flex">
              {[...Array(5)].map((_, index) => (
                <div key={index} onClick={() => handleStarClick(index)}>
                  {index < selectedStars ? (
                    <StarFill className="star-icon" />
                  ) : (
                    <Star className="star-icon" />
                  )}
                </div>
              ))}
            </div>
            {selectedStarsErr && <p className="text-danger">{selectedStarsErr}</p>}
          </div>

          <div className="mb-3">
            <p className="mb-1">Write your review:</p>
            <textarea
              className="form-control"
              rows="4"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              placeholder="Write your review here..."
            />
          </div>
          {reviewTextErr && <p className="text-danger">{reviewTextErr}</p>}

          {/* Display server error if there is one */}
          {serverError && <p className="text-danger">{serverError}</p>}

          <div className="send-modal-footer">
            <button className="saveChanges-button mx-3" onClick={handleSubmit}>
              Confirm
            </button>
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
          </div>
        </div>
      </div>
    );
  }
}
